import { render, staticRenderFns } from "./SfReview.vue?vue&type=template&id=523f0ca0"
import script from "./SfReview.vue?vue&type=script&lang=js"
export * from "./SfReview.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfReview.vue?vue&type=style&index=0&id=523f0ca0&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "33c340d2"
  
)

export default component.exports